import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as S from './SearchEmailResult.styled';

interface LocationState {
  email: string;
  createdAt: string;
}

function SearchEmailResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  // state가 없으면 searchmain으로 리다이렉트
  React.useEffect(() => {
    if (!state || !state.email) {
      navigate('/searchmain', { replace: true });
    }
  }, [state, navigate]);

  if (!state || !state.email) {
    return null;
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}.${month}.${day}`;
  };

  const handlePasswordFind = () => {
    navigate('/searchmain', { state: { activeTab: 'password' } });
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <S.Page>
      <S.Header>아이디/비밀번호 찾기</S.Header>

      <S.ContentWrap>
        <S.ResultBox>
          <S.Message>회원님의 정보와 일치하는 아이디 입니다.</S.Message>

          <S.InfoSection>
            <S.InfoRow>
              <S.InfoLabel>아이디 :</S.InfoLabel>
              <S.InfoValue>{state.email}</S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>가입일 :</S.InfoLabel>
              <S.InfoValue>{formatDate(state.createdAt)}</S.InfoValue>
            </S.InfoRow>
          </S.InfoSection>
        </S.ResultBox>
      </S.ContentWrap>

      <S.ButtonContainer>
        <S.OutlineButton onClick={handlePasswordFind}>
          비밀번호 찾기
        </S.OutlineButton>
        <S.SolidButton onClick={handleLogin}>
          로그인
        </S.SolidButton>
      </S.ButtonContainer>
    </S.Page>
  );
}

export default SearchEmailResult;
